// src/pages/VerifyCallback.js
import React, { useEffect, useState } from "react";
import {
    Box,
    Text,
    Spinner,
    useToast
} from "@chakra-ui/react";
import { useSearchParams, useNavigate } from "react-router-dom";
import {useServerIP} from "../../../redux/ServerIPContext";
import {useAuth} from "../../../redux/AuthProvider";
import {maxOutUsage} from "../../../utils/redux-helpers";
import axios from "axios";

export default function VerifyCallback() {
    const [searchParams] = useSearchParams();
    const hash = searchParams.get("hash");
    const [loading, setLoading] = useState(true);
    const toast = useToast();
    const navigate = useNavigate();
    const auth = useAuth();
    const { serverIPs, setServerIPs, isDev } = useServerIP();

    useEffect(() => {
        if (!hash) {
            toast({
                title: "Invalid link.",
                status: "error",
                duration: 5000,
                isClosable: true,
            });
            console.log("HASHHHHH", hash);
            return navigate("/");
        }
        (async () => {
            try {
                console.log("HASHHHHH 23456", hash);
                const response = await axios.post(serverIPs.SERVER_IP + '/verify_google_auth_callback_token', {
                    token: hash
                });
                console.log("RES for /verify_google_auth_callback_token", response);

                if (response.data.status === 200) {
                    window.gtag('event', 'sign_up', {
                        'event_category': 'Sign Up',
                        'event_label': 'Sign Up Method',
                        'value': 'success'
                    });

                    //set local storage userID equal to response.userID
                    localStorage.setItem('email', response.data.message.email.toString());
                    localStorage.setItem('firstName', response.data.message.first_name.toString());
                    localStorage.setItem('lastName', response.data.message.last_name.toString());
                    auth.login(response.data.message.userID);
                    auth.setIsLoggedIn(true);
                    // setVerificationCode('')
                    // onClose();
                    console.log("HERERERERE DONALD TRUMP");

                    const wasUploadExceeded = localStorage.getItem('isUploadExceeded') ?
                        JSON.parse(localStorage.getItem('isUploadExceeded')) : null;
                    const wasChatExceeded = localStorage.getItem('isChatExceeded') ?
                        JSON.parse(localStorage.getItem('isChatExceeded')) : null;

                    let keysToMax = [];
                    if (wasUploadExceeded) {
                        keysToMax.push("pdf_uploads");
                    }
                    console.log("HERERERERE OBAMA 2");
                    if (wasChatExceeded) {
                        keysToMax.push("chats");
                    }
                    if (keysToMax.length > 0) {
                        maxOutUsage(response.data.message.userID, keysToMax, serverIPs.SERVER_IP).then(r => {
                            if (r.status === 200) {
                                console.log('maxed out usage success');
                            }
                        });
                    }
                    console.log("HERERERERE DONALD TRUMP 2");
                }
                setLoading(false)
                navigate('/');

















                // redirect based on whether it was a signup or signin
                // if (data.action === "signup_new_user") {
                //     navigate("/welcome");
                // } else {
                //     navigate("/dashboard");
                // }
            } catch (err) {
                console.error(err);
                toast({
                    title: "Verification failed.",
                    description: err.message,
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                });
                navigate("/");
            } finally {
                setLoading(false);
            }
        })();
    }, [hash]);

    return (
        <Box p={6} textAlign="center">
            {loading ? (
                <>
                    <Spinner size="xl" />
                    <Text mt={4}>Verifying your account…</Text>
                </>
            ) : null}
        </Box>
    );
}
